import React, { useEffect, useState } from "react";
import { Globe2, Instagram } from "lucide-react";
import { api } from "../lib/api";

const PUBLIC_PATHS = ["/auth/callback"]; // never block these

export const GeoGate = ({ children }) => {
  const [state, setState] = useState({ checking: true, allowed: true, country: "" });

  useEffect(() => {
    if (PUBLIC_PATHS.some((p) => window.location.pathname.startsWith(p))) {
      setState({ checking: false, allowed: true, country: "IN" });
      return;
    }
    api.get("/geo/check")
      .then((r) => setState({ checking: false, allowed: r.data.allowed, country: r.data.country || "", bypass: r.data.bypass }))
      .catch(() => setState({ checking: false, allowed: true, country: "" })); // fail-open
  }, []);

  if (state.checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <p className="text-brand-muted text-sm">Loading Joy Pearl…</p>
      </div>
    );
  }

  if (!state.allowed) {
    return (
      <div className="min-h-screen bg-brand-bg flex items-center justify-center px-6" data-testid="india-only-gate">
        <div className="max-w-md text-center">
          <div className="mx-auto h-14 w-14 rounded-full bg-brand-primary text-white flex items-center justify-center mb-6"><Globe2 size={26}/></div>
          <p className="jp-eyebrow mb-3">Joy Pearl</p>
          <h1 className="font-serif text-3xl md:text-4xl text-brand-ink leading-tight">
            We're available only in <em className="text-brand-primary not-italic">India</em> right now.
          </h1>
          <p className="text-brand-muted mt-4 text-sm leading-relaxed">
            Joy Pearl currently ships only within India. We detected your visit from <span className="font-medium text-brand-ink">{state.country || "outside India"}</span> and our online store isn't open to international orders yet.
          </p>
          <p className="text-brand-muted mt-3 text-sm">
            Follow us for international launch updates:
          </p>
          <a href="https://www.instagram.com/joypearl_official" target="_blank" rel="noopener noreferrer"
             className="mt-4 inline-flex items-center gap-2 text-brand-primary hover:underline">
            <Instagram size={16}/> @joypearl_official
          </a>
          <p className="mt-10 text-[11px] uppercase tracking-[0.2em] text-brand-muted">
            © Vasudevaya Sreekrishna Enterprises<br/>GSTIN 06BITPK7883H1ZH • Gurgaon, Haryana
          </p>
        </div>
      </div>
    );
  }

  return children;
};
